import React, { useState } from "react";
import {
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Container,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export default function FAQSection() {
  const [expanded, setExpanded] = useState("panel1");

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  const faqData = [
    {
      id: "panel1",
      question: "What is Zutopay?",
      answer: "Zutopay is a secure and easy-to-use mobile payment platform that lets you pay, send, and receive money instantly. Whether you're shopping online or paying bills, Zutopay makes transactions fast, reliable, and stress-free.",
    },
    { 
      id: "panel2", 
      question: "Is Zutopay safe to use?",
      answer: "Yes, Zutopay uses bank-level encryption and multi-factor authentication to ensure your transactions and personal information are always protected. We also offer 24/7 fraud monitoring and zero-liability protection for unauthorized transactions."
    },
    { 
      id: "panel3", 
      question: "How do I make a payment using Zutopay?",
      answer: "Making a payment with Zutopay is simple: 1) Open the Zutopay app, 2) Select 'Send Money' or 'Pay', 3) Enter the recipient's details or scan their QR code, 4) Enter the amount and add a note if needed, 5) Confirm the payment with your PIN or biometric authentication."
    },
    { 
      id: "panel4", 
      question: 'What happens if my payment shows as "Pending"?',
      answer: "A pending payment usually means the transaction is being processed. This typically takes 1-2 business days. If the status doesn't update within this time, please check your internet connection, ensure you have sufficient balance, or contact our support team for assistance."
    },
    { 
      id: "panel5", 
      question: "Can I use Zutopay internationally?",
      answer: "Yes, Zutopay works internationally in over 150 countries. You can send money abroad, make international purchases, and even withdraw cash at partner ATMs worldwide. Currency conversion is done automatically at competitive exchange rates."
    },
    { 
      id: "panel6", 
      question: "Is there a fee for using Zutopay?",
      answer: "Zutopay offers many free services including account opening, receiving money, and local transfers between Zutopay users. Some services may have fees, such as instant transfers, international transactions, or currency conversion, which will be clearly displayed before you confirm any transaction."
    },
  ];

  return (
    <Box sx={{ backgroundColor: '#f8f8f8', py: 8 }}>
      <Container maxWidth="md" sx={{ fontFamily: '"SF Pro Display", "Helvetica", "Arial", sans-serif' }}>
      {/* Title */}
     <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 1, textAlign: 'center', fontFamily: 'inherit' }}>
                     Frequently Asked Questions
                 </Typography>

      {/* Subtitle */}
      <Typography
        align="center"
        sx={{
          color: "gray",
          mb: 4,
          fontSize: "0.9rem",
          textAlign: 'center'
        }}
      >
        Got questions? We’ve got answers.
        <br />
        Learn everything you need to know about using Zutopay in just a few seconds.
      </Typography>

      {/* FAQ List */}
      {faqData.map((item) => (
        <Accordion
          key={item.id}
          expanded={expanded === item.id}
          onChange={handleChange(item.id)}
          sx={{
            backgroundColor: '#f8f8f8',
            boxShadow: "none",
            borderBottom: "1px solid #eee",
            "&:before": { display: "none" },
            '&.Mui-expanded': {
              backgroundColor: '#f8f8f8',
              margin: 0,
            },
            '&:hover': {
              backgroundColor: '#f8f8f8',
            },
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon sx={{ color: "#000" }} />}
            sx={{
              backgroundColor: 'transparent',
              fontWeight: 500,
              color: expanded === item.id ? '#1976d2' : '#000',
              fontFamily: 'inherit',
              '&:hover': {
                color: expanded === item.id ? '#1976d2' : '#000',
              },
              '&.Mui-expanded': {
                color: '#1976d2',
              },
              '& .MuiAccordionSummary-content': { 
                my: 1,
                fontFamily: 'inherit',
              },
            }}
          >
            {item.question}
          </AccordionSummary>

          {item.answer && (
            <AccordionDetails sx={{ 
              color: "gray", 
              fontSize: "0.9rem", 
              mb: 1,
              fontFamily: 'inherit',
              backgroundColor: 'transparent',
              '&.MuiAccordionDetails-root': {
                padding: '8px 16px 16px',
              }
            }}>
              {item.answer}
            </AccordionDetails>
          )}
        </Accordion>
      ))}
      </Container>
    </Box>
  );
}
